import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartColumn,
  faAdd,
  faSignOut,
  faUsers,
  faFileInvoice,
  faFlag,
  faPeopleRoof,
  faUserTie,
  faPeopleGroup,
  faCoins,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faBolt,
  faScrewdriverWrench,
  faDiceD20,
  faBaseball,
  faGamepad,
} from "@fortawesome/free-solid-svg-icons";
import { useAbility } from "@casl/react";
import { homePath } from "../rbac/homePath";
import { AbilityContext, Can } from "../rbac/Can";
import { novigAccounts, antNovigAccounts } from "../pages/protected/novigbalances/novigAccounts";
import { balanceName } from "../pages/protected/novigbalances/balanceOverviewModel";
import Logo from "./Logo";

const menuGroups = [
  { key: "balances", icon: faCoins, title: "Balances", items: [
    { icon: faChartColumn, title: "Overview", url: "/admin/balances-overview", subject: "balances", action: "view" },
    { key: "novig", icon: faCoins, title: balanceName('novig'), url: "/admin/novig-balances", subject: "balances", action: "view", children: novigAccounts.map(account => ({ title: account.name, url: `/admin/novig-balances/${account.slug}` })) },
    { key: "ant-novig", icon: faCoins, title: balanceName('ant-novig'), url: "/admin/ant-novig-balances", subject: "balances", action: "view", children: antNovigAccounts.map(account => ({ title: account.name, url: `/admin/ant-novig-balances/${account.slug}` })) },
    { icon: faCoins, title: balanceName('prophetx'), url: "/admin/prophetx-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('kalshi'), url: "/admin/kalshi-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('polyus-dk'), url: "/admin/polyus-dk-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('greg-polyus'), url: "/admin/greg-polyus-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('ant-polyus-inst'), url: "/admin/ant-polyus-inst-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('sonya-prophetx'), url: "/admin/sonya-prophetx-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('ant-prophetx'), url: "/admin/ant-prophetx-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('yan-prophetx'), url: "/admin/yan-prophetx-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('polymarket-dk-mm'), url: "/admin/polymarket-dk-mm-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('polymarket-carlos-matt-ct'), url: "/admin/polymarket-carlos-matt-ct-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('polymarket-carlos-arb'), url: "/admin/polymarket-carlos-arb-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('polymarket-carlos-fido-ct'), url: "/admin/polymarket-carlos-fido-ct-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('a2-kalshi'), url: "/admin/a2-kalshi-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('eddy-kalshi'), url: "/admin/eddy-kalshi-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('yan-kalshi'), url: "/admin/yan-kalshi-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('greg-kalshi'), url: "/admin/greg-kalshi-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('ant-kalshi'), url: "/admin/ant-kalshi-balances", subject: "balances", action: "view" },
    { icon: faCoins, title: balanceName('polyus-fido-ct'), url: "/admin/polyus-fido-ct-balances", subject: "balances", action: "view" },
  ] },
  {
    key: "live-feed",
    icon: faBolt,
    title: "ODDS",
    items: [
      {
        icon: faBaseball,
        title: "MLB",
        url: "/admin/live-feed",
        subject: "live-feed",
        action: "view",
      },
      {
        icon: faDiceD20,
        title: "WNBA",
        url: "/admin/wnba-models",
        subject: "wnba-models",
        action: "view",
      },
      {
        icon: faGamepad,
        title: "LoL",
        url: "/admin/lol",
        subject: "live-feed",
        action: "view",
      },
    ],
  },
  {
    key: "accounts",
    icon: faFileInvoice,
    title: "Accounts",
    items: [
      {
        icon: faFileInvoice,
        title: "Accounts",
        url: "/admin/accounts",
        subject: "accounts",
        action: "view",
      },
      {
        icon: faChartColumn,
        title: "Figures",
        url: "/admin/daily-figures",
        subject: "daily-figures",
        action: "view",
      },
      {
        icon: faCoins,
        title: "Balance",
        url: "/admin/account-balance",
        subject: "account-balance",
        action: "view",
      },
      {
        icon: faScrewdriverWrench,
        title: "Tools",
        url: "/admin/tools",
        subject: "tools",
        action: "view",
      },
      {
        icon: faUsers,
        title: "Handicappers",
        url: "/admin/handicappers",
        subject: "handicappers",
        action: "view",
      },
      {
        icon: faAdd,
        title: "Add New Bet",
        url: "/admin/daily-figure/add",
        subject: "daily-figures",
        action: "create",
      },
      {
        icon: faUserTie,
        title: "Managers",
        url: "/admin/managers",
        subject: "managers",
        action: "view",
      },
      {
        icon: faPeopleGroup,
        title: "Bettors",
        url: "/admin/bettors",
        subject: "bettors",
        action: "view",
      },
      {
        icon: faPeopleRoof,
        title: "Agents",
        url: "/admin/agents",
        subject: "agents",
        action: "view",
      },
      {
        icon: faFlag,
        title: "Bets",
        url: "/admin/bets",
        subject: "bets",
        action: "view",
      },
    ],
  },
];

export default function Sidebar({ isExpanded, onToggleExpanded }) {
  const location = useLocation();
  const currentPath = location.pathname;
  const ability = useAbility(AbilityContext);
  const [userName, setUserName] = useState(null);
  const [openGroups, setOpenGroups] = useState({});

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      setUserName(user.name);
    }
  }, []);

  const isActive = (url) => {
    if (url === "/admin/accounts") {
      return currentPath.startsWith("/admin/accounts");
    }
    return currentPath === url || currentPath.startsWith(`${url}/`);
  };

  // Drop whole groups the user cannot see any part of, so an empty heading
  // never appears.
  const groups = menuGroups
        .map((group) => ({
          ...group,
          items: group.items.filter((item) => ability.can(item.action, item.subject)),
        }))
        .filter((group) => group.items.length);

  const activeGroupKey = groups.find((group) =>
    group.items.some((item) => isActive(item.url))
  )?.key;

  // Whichever group holds the current page opens itself, so landing on a URL
  // directly still shows where you are.
  useEffect(() => {
    if (activeGroupKey) {
      setOpenGroups((open) => ({ ...open, [activeGroupKey]: true, ...(currentPath.startsWith('/admin/novig-balances') ? { novig: true } : {}), ...(currentPath.startsWith('/admin/ant-novig-balances') ? { 'ant-novig': true } : {}) }));
    }
  }, [activeGroupKey, currentPath]);

  const toggleGroup = (key) => {
    // Collapsed down to icons there is no room for a submenu, so open the
    // sidebar first rather than showing nothing.
    if (!isExpanded) {
      onToggleExpanded();
      setOpenGroups((open) => ({ ...open, [key]: true }));
      return;
    }
    setOpenGroups((open) => ({ ...open, [key]: !open[key] }));
  };

  return (
    <aside
      className={`admin-sidebar transition-all duration-300 ${
        isExpanded ? "w-64" : "w-[84px]"
      }`}
    >
      <div className={`border-b border-sidebar-border px-3 py-4 ${isExpanded ? "px-4" : "flex flex-col items-center gap-3"}`}>
        <div className={`flex w-full ${isExpanded ? "items-center justify-between" : "flex-col items-center gap-3"}`}>
          <Logo variant="light" compact={!isExpanded} to={homePath(ability)} />
          <button
          type="button"
          onClick={onToggleExpanded}
          className="rounded-lg border border-sidebar-border p-2 text-slate-400 transition hover:bg-sidebar-hover hover:text-white"
          aria-label={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
        >
          <FontAwesomeIcon icon={isExpanded ? faChevronLeft : faChevronRight} />
        </button>
        </div>
      </div>

      {userName && isExpanded && (
        <div className="border-b border-sidebar-border px-4 py-4">
          <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500">Signed in</p>
          <p className="mt-1 truncate text-sm font-medium text-white">{userName}</p>
        </div>
      )}

      <nav className="flex-1 overflow-y-auto px-3 py-4">
        <ul className="space-y-1">
          {groups.map((group) => {
            const isOpen = isExpanded && !!openGroups[group.key];
            const holdsCurrentPage = group.key === activeGroupKey;

            return (
              <li key={group.key}>
                <button
                  type="button"
                  onClick={() => toggleGroup(group.key)}
                  aria-expanded={isOpen}
                  title={group.title}
                  className={`flex w-full items-center gap-3 rounded-xl px-3 py-3 text-sm font-medium transition ${
                    holdsCurrentPage
                      ? "text-white"
                      : "text-slate-400 hover:bg-sidebar-hover hover:text-white"
                  }`}
                >
                  <FontAwesomeIcon icon={group.icon} className="w-4 shrink-0" />
                  {isExpanded && (
                    <>
                      <span className="flex-1 text-left">{group.title}</span>
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        className={`w-3 shrink-0 text-xs transition-transform duration-200 ${
                          isOpen ? "rotate-180" : ""
                        }`}
                      />
                    </>
                  )}
                </button>

                {isOpen && (
                  <ul className="mt-1 space-y-1 border-l border-sidebar-border pl-3 ml-5">
                    {group.items.map((item) => (
                      <li key={item.url}>
                        {item.children ? <>
                          <button type="button" aria-expanded={!!openGroups[item.key]} onClick={() => toggleGroup(item.key)} className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm font-medium text-slate-300 hover:bg-sidebar-hover hover:text-white">
                            <FontAwesomeIcon icon={item.icon} className="w-4 shrink-0" /><span className="flex-1">{item.title}</span><FontAwesomeIcon icon={faChevronDown} className={`w-3 transition-transform ${openGroups[item.key] ? 'rotate-180' : ''}`} />
                          </button>
                          {openGroups[item.key] && <ul className="ml-5 space-y-1 border-l border-sidebar-border pl-2">{item.children.map(child => <li key={child.url}><Link to={child.url} className={`block rounded-lg px-3 py-2 text-sm ${isActive(child.url) ? 'bg-white/10 text-white ring-1 ring-white/10' : 'text-slate-400 hover:bg-sidebar-hover hover:text-white'}`}>{child.title}</Link></li>)}</ul>}
                        </> : <Link
                          to={item.url}
                          className={`flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition ${
                            isActive(item.url)
                              ? "bg-white/10 text-white shadow-inner ring-1 ring-white/10"
                              : "text-slate-400 hover:bg-sidebar-hover hover:text-white"
                          }`}
                          title={item.title}
                        >
                          <FontAwesomeIcon icon={item.icon} className="w-4 shrink-0" />
                          <span>{item.title}</span>
                        </Link>}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="border-t border-sidebar-border p-3">
        <Can I="logout" a="auth">
          <Link
            to="/logout"
            className="flex items-center gap-3 rounded-xl px-3 py-3 text-sm font-medium text-slate-400 transition hover:bg-rose-500/10 hover:text-rose-300"
          >
            <FontAwesomeIcon icon={faSignOut} className="w-4 shrink-0" />
            {isExpanded && <span>Logout</span>}
          </Link>
        </Can>
      </div>
    </aside>
  );
}
